module.exports = __webpack_public_path__ + "assets/img/3.6bd8361a.jpg";